import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import { useSponsor } from '../context/SponsorContext';

const HERO_IMG = `${process.env.REACT_APP_IMAGE_URL}/assets/images/Cartoon_Marriage_Pic_Compressed.png`;

export default function AuthLayout({ children }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const { authBg } = useSponsor();

    useEffect(() => {
        const h = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', h);
        return () => window.removeEventListener('resize', h);
    }, []);

    if (isMobile) {
        return (
            <div style={{ minHeight: '100vh', background: 'white', overflowY: 'auto' }}>
                <div style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '32px 20px',
                    boxSizing: 'border-box',
                }}>
                    <div style={{ width: '100%', maxWidth: '400px' }}>
                        {children}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{ fontFamily: 'Calibri, sans-serif', minHeight: '100vh', background: 'white', overflow: 'hidden' }}>
            <Row style={{ minHeight: '100vh', margin: 0 }}>
                <Col md={14} style={{
                    position: 'relative', overflow: 'hidden',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    <div style={{
                        position: 'absolute', inset: 0,
                        backgroundImage: authBg ? `url(${authBg})` : `url(${HERO_IMG})`,
                        backgroundSize: 'cover', backgroundPosition: 'center top',
                    }} />
                </Col>
                <Col md={10} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'white', padding: '80px 24px 40px', overflowY: 'auto',
                }}>
                    <div style={{ width: '100%', maxWidth: '380px' }}>
                        {children}
                    </div>
                </Col>
            </Row>
        </div>
    );
}
